import type { FC} from 'react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNetworkStatus } from '@/shared/hooks/useNetworkStatus';

/**
 * Shows a brief success toast when connection is restored
 * Auto-dismisses after 3 seconds
 */
export const OnlineToast: FC = () => {
  const { wasOffline } = useNetworkStatus();

  useEffect(() => {
    if (wasOffline) {
      toast.success('Back online', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      });
    }
  }, [wasOffline]);

  // This component doesn't render anything visible
  // It just triggers the toast
  return null;
};
